export const StanekConstants: {
  RAMBonus: number;
  BaseSize: number;
  MaxSize: number;
} = {
  RAMBonus: 0.1,
  BaseSize: 9,
  MaxSize: 25,
};
